<template>
  <v-app>
    <v-container class="appclick">
      <Header>
        <font-awesome-icon :icon="['fas', 'diagnoses']" />
        <font-awesome-icon :icon="['fas', 'cogs']" />
        <router-link :to="{ name: 'settings_routing' }">
          <font-awesome-icon
            :icon="['fas', 'route']"
            :style="{ color: 'green' }"
        /></router-link>
        <font-awesome-icon :icon="['fas', 'balance-scale']" />
        <span class="title">Routing {{ $route.params.id }}</span>
      </Header>
      <v-row>
        <v-col class="col-7">
          <div id="map" class="map"></div>
          <pagination
            class="pagination col-xs-12"
            v-model="o_slider"
            :total-page="n_objects"
            boundary-links
            pills
            size="lg"
            @change="changeObject(o_slider)"
          />
        </v-col>
        <v-col class="col-5">
          <Player
            ref="RefPlayer"
            :first="object.frame_first"
            :last="object.frame_last"
            :fps="fields.field_fps"
            :video="video"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="col-4">
          <h1 v-if="object.des == -1">
            <font color="red">{{ object.org }} > {{ object.des }}</font>
          </h1>
          <h1 v-else>
            <font color="green">{{ object.org }} > {{ object.des }}</font>
          </h1>
        </v-col>

        <v-col class="col-4">{{ object.obj }} </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
import ProjectService from "@/services/ProjectService.js";
import Header from "@/components/Header.vue";
import Player from "@/components/Player.vue";
import Map from "ol/Map";
import View from "ol/View";
import "ol/ol.css";
import { Vector as VectorSource } from "ol/source";
import ImageLayer from "ol/layer/Image";
import { Vector as VectorLayer } from "ol/layer";
import { Select } from "ol/interaction";
import { Fill, Stroke, Style, Text } from "ol/style";
import GeoJSON from "ol/format/GeoJSON";
import Static from "ol/source/ImageStatic";
import Projection from "ol/proj/Projection";
import { getCenter } from "ol/extent";
var vectorsource;
var vectorsourcezones;
var vectorlayerzones;
var vectorlayer;
var select = new Select({
  style: overlayStyle
});
var overlayStyle = function() {
  var styles = {};
  styles["Polygon"] = [
    new Style({
      fill: new Fill({
        color: [255, 255, 255, 0.5]
      })
    }),
    new Style({
      stroke: new Stroke({
        color: [255, 255, 255, 1],
        width: 5
      })
    }),
    new Style({
      stroke: new Stroke({
        color: [0, 153, 255, 1],
        width: 3
      })
    })
  ];
};
var extent = [0, 0, 720, 480];
var projection = new Projection({
  code: "static-image",
  units: "pixels",
  extent: extent
});
var style = new Style({
  fill: new Fill({
    color: "rgba(255, 0, 0, 0.1)"
  }),
  stroke: new Stroke({
    color: "#FF0000",
    width: 3
  }),
  text: new Text({
    font: "16px Calibri,sans-serif",
    fill: new Fill({
      color: "#000"
    }),
    stroke: new Stroke({
      color: "#fff",
      width: 2
    })
  })
});

export default {
  components: {
    Header,
    Player
  },
  data: function() {
    return {
      objects: {},
      object: {},
      classes: {},
      fields: {},
      nobject: {},
      map: null,
      no: true,
      n_objects: 0,
      o_min: 1,
      o_max: 100,
      o_per_page: 10,
      o_slider: 1,
      starttijd: 60,
      duur: 120,
      video: ""
    };
  },
  mounted() {
    let ex_slider = this.o_slider;
    this.o_slider = ex_slider;
    let vars = { route_confidence_id: this.$route.params.id };
    ProjectService.apiGet({
      nid: this.$session.get("PROJID"),
      type: "settings_routing_test",
      vars: vars
    })
      .then(response => {
        console.log(response.data);
        this.objects = response.data.objects;
        this.n_objects = response.data.n;
        this.fields = response.data.fields;
        this.video = response.data.fields.video;
        this.zones = response.data.zones;
        this.o_slider = 1;
        this.changeObject(this.o_slider);
      })
      .catch(error => {
        console.log("Fout " + error.response);
      });
  },

  methods: {
    changeObject(o_slider) {
      let _this = this;
      var clearmap = document.getElementById("map");
      clearmap.innerHTML = "";
      this.object = this.objects[o_slider];
      var graph_id = this.object.obj;
      var show_id = this.object.frame;
      this.o_max = this.objects.length - 1;
      vectorsource = new VectorSource({
        format: new GeoJSON(),
        url:
          "https://trafficdistillery.com/tracking/getmosaicgraph/" +
          this.$session.get("PROJID") +
          "/" +
          graph_id
      });
      vectorsourcezones = new VectorSource({
        features: new GeoJSON().readFeatures(this.zones)
      });
      vectorlayerzones = new VectorLayer({
        source: vectorsourcezones,
        style: styleFunction,
        name: "zones"
      });
      function styleFunction(feature) {
        var att = feature.getProperties();
        return [
          new Style({
            fill: new Fill({
              color: "rgba(0, 255, 0, 0)"
            }),
            stroke: new Stroke({
              color: "#00ff00",
              width: 2
            }),
            text: new Text({
              font: "40px Calibri,sans-serif",
              fill: new Fill({ color: "#000" }),
              text: "" + att.id
            })
          })
        ];
      }
      var image = new ImageLayer({
        source: new Static({
          url:
            "https://trafficdistillery.com/sites/default/files/project/" +
            this.$session.get("PROJID") +
            "/images/" +
            show_id +
            ".jpg",
          projection: projection,
          size: [720, 480],
          imageExtent: extent
        })
      });
      vectorlayer = new VectorLayer({
        source: vectorsource,
        style: function(feature) {
          style.getText().setText(feature.get("label"));
          return style;
        }
      });
      var map = new Map({
        interactions: [select],
        layers: [image, vectorlayer, vectorlayerzones],
        target: "map",
        controls: [],
        view: new View({
          projection: projection,
          center: getCenter(extent),
          zoom: 1.3,
          attribution: true
        })
      });
      map.on("click", selectzone);
      function selectzone(evt) {
        var selected_polygon_style = {
          strokeWidth: 5,
          strokeColor: "#ff0000"
        };
        var pixel = evt.pixel;
        map.forEachFeatureAtPixel(pixel, function(feature, layer) {
          if (layer.values_.name == "zones")
            if (feature) {
              let zone = feature.values_.id;
              _this.selectzone(zone);
              feature.style = selected_polygon_style;
            }
        });
      } // displayTooltip
      //this.StartVideo();
    }
  }
};
</script>

<style scoped>
.clickimages {
  border-width: thin;
  border-style: solid;
}
.map {
  height: 420px;
  width: 630px;
}

button {
  margin-left: 10px;
  font-size: 10px;
}

.imagetext {
  vertical-align: middle;
}
h6 {
  height: 30px;
}
.video-js {
  width: 630px;
  height: 420px;
}
</style>
